<template>
  <div class="inner-content groupings-search">
    <div class="flex-row search-row-section">
      <div class="flex-row-item flex-bulk-actions">
        <asset-bulk-actions />
      </div>
      <div class="flex-row-item flex-search-input">
        <search-input />
      </div>
    </div>
    <div class="table-container">
      <search-results />
    </div>
    <delete-confirmation>
      <template slot="name">
        {{ asset.name }}
      </template>
      <template slot="body">
        {{ appsCount }} apps use this grouping.
      </template>
    </delete-confirmation>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AssetBulkActions from '../shared/BulkActions.vue'
import SearchInput from '../shared/SearchInput.vue'
import SearchResults from '../../shared/SearchResults.vue'
import DeleteConfirmation from '../shared/DeleteConfirmation.vue'
import searchKeys from '../../../mixins/search-keys.js'

export default {
  components: {
    AssetBulkActions,
    SearchInput,
    SearchResults,
    DeleteConfirmation
  },
  mixins: [searchKeys],
  data () {
    return {
      groupingTypes: [
        {
          name: 'Case Study'
        },
        {
          name: 'Exhibit'
        },
        {
          name: 'Item Cluster'
        },
        {
          name: 'Progress'
        },
        {
          name: 'Quiz'
        },
        {
          name: 'Scenario Box'
        },
        {
          name: 'Standard'
        }
      ]
    }
  },
  computed: {
    appsCount () {
      if (this.asset.id) {
        return this.asset.apps.length
      } else {
        return 'unknown'
      }
    },
    ...mapGetters([
      'asset',
      'tags'
    ])
  },
  async created () {
    await this.getTags()
    this.setAssetType({ assetType: 'grouping' })
    const keys = [
      { key: 'ids', display_name: 'IDs', type: 'text' },
      { key: 'products', display_name: 'Product', type: 'product' },
      { key: 'category_type_ids', display_name: 'Category Type', type: 'category_type' },
      { key: 'name', display_name: 'Name', type: 'text' },
      { key: 'grouping_types', display_name: 'Grouping Type', type: 'multiple_autocomplete', options: this.groupingTypes, trackBy: 'name', label: 'name' },
      { key: 'display_title', display_name: 'Display Title', type: 'text' },
      { key: 'display_description', display_name: 'Display Description', type: 'text' },
      { key: 'display_attachment_id', display_name: 'Display Attachment ID', type: 'text' },
      { key: 'difficulty_level', display_name: 'Difficulty Level', type: 'text' },
      { key: 'tags', display_name: 'Tags', type: 'multiple_autocomplete', options: this.tags, trackBy: 'name', label: 'name' },
      { key: 'created_at', display_name: 'Created At', type: 'date_range' },
      { key: 'updated_at', display_name: 'Updated At', type: 'date_range' },
      { key: 'revised_at', display_name: 'Revised At', type: 'date_range' }
    ]

    this.setAvailableKeys(keys)
  },
  methods: {
    ...mapMutations([
      'setAssetType'
    ]),
    ...mapActions([
      'getTags'
    ])
  }
}
</script>
<style lang="scss">
.groupings-search {
  .table-container {
    border: 1px solid $grey-2;
  }
}
</style>
